import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  // List,
  ListItem,
  withStyles,
  Grid,
  ListItemSecondaryAction,
} from '@material-ui/core'
import Menu from '../Menu'
import types from './types'
import Stats from './Stats'
import language from 'utils/vast-languagepack'
import classNames from 'classnames'
import { stepperGoTo } from 'actions/view'

export default connect(null, dispatch =>
  bindActionCreators({ stepperGoTo }, dispatch),
)(
  withStyles(theme => ({
    expandPanelIcon: {
      color: theme.palette.secondary.main,
      textAlign: 'center',
      position: 'absolute',
      left: 43,
      top: '50%',
      [theme.breakpoints.down('sm')]: {
        // top: 65,
        left: 40,
      },
    },
    expandPanelIconTypography: {
      color: theme.palette.secondary.main,
      fontWeight: 'bold',
      fontSize: '9px',
      width: 73,
      lineHeight: 1.3,
      marginTop: '-4px',
    },
    expandPanelIconInner: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      fontWeight: 'bold',
      display: 'table',
      tableLayout: 'fixed',
      width: '100%',
      whiteSpace: 'nowrap',
      marginBottom: 5,
    },
    description: {
      color: theme.palette.text.secondary,
      fontSize: theme.typography.pxToRem(15),
      display: 'table',
      tableLayout: 'fixed',
      width: '100%',
      whiteSpace: 'nowrap',
      marginBottom: 5,
    },
    createdHeading: {
      color: theme.palette.text.secondary,
      fontSize: theme.typography.pxToRem(12),
      fontWeight: 'bold',
      display: 'table',
      tableLayout: 'fixed',
      width: '100%',
      whiteSpace: 'nowrap',
      [theme.breakpoints.down('xs')]: {
        fontSize: theme.typography.pxToRem(11),
      },
    },
    text: {
      display: 'table-cell',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    createdDate: {
      color: theme.palette.secondary.main,
      display: 'inline-block',
    },
    secondaryAction: {
      [theme.breakpoints.up('xs')]: {
        paddingRight: 33,
      },
      [theme.breakpoints.up('md')]: {
        paddingRight: 60,
      },
    },
    container: {
      listStyle: 'none',
      borderBottom: '1px solid #adadad',
      borderRight: '1px solid #adadad',
    },
    secondaryActionRoot: {
      [theme.breakpoints.up('xs')]: {
        top: 'calc(50% - 16px)',
      },
      [theme.breakpoints.up('md')]: {
        top: 'calc(50% - 24px)',
      },
    },
    info: {
      display: 'inline-block',
      marginLeft: 75,
      [theme.breakpoints.down('sm')]: {
        marginLeft: 68,
      },
    },
  }))(
    ({
      classes,
      addOrEditPush,
      task,
      size,
      entityType,
      stepperGoTo,
      isPinned,
    }) => {
      const date = new Date(task.when_created)
      const stats = task.email_stats
        ? 'email_stats'
        : task.sms_stats
        ? 'sms_stats'
        : null

      return (
        <ListItem
          onClick={() => {
            // if (task.task_type_id === '1') {
            //   stepperGoTo(3, 'task')
            // } else {
            //   stepperGoTo(2, 'task')
            // }
            addOrEditPush(task.id)
          }}
          key={`tasksPageListItem${task.id}`}
          button
          classes={{
            container: classes.container,
            secondaryAction: classes.secondaryAction,
          }}
        >
          <div className={classNames(classes.expandPanelIcon)}>
            {types(task, classes)?.icon}
          </div>
          <Grid container className={classes.info}>
            <Grid item md={12} lg={6}>
              <div className={classes.heading}>
                <span className={classes.text}>
                  {isPinned ? '📌 ' : ''}
                  {task.name}
                </span>
              </div>
            </Grid>
            <Grid item md={12} lg={6}>
              <div className={classes.description}>
                <span className={classes.text}>{task.description}</span>
              </div>
            </Grid>
            <Grid item xs={12}>
              <div className={classes.createdHeading}>
                <span className={classes.text}>
                  <em>
                    <span>
                      <span>{`${language.task.menuSort.created} `}</span>
                      <span className={classes.createdDate}>
                        {`${date.toLocaleDateString()}`}
                      </span>
                    </span>
                    {types(task, classes)?.scheduled}
                  </em>
                </span>
              </div>
            </Grid>
            {size === 'small' && stats ? (
              <Grid item xs={12}>
                <Stats
                  stats={task[stats]}
                  taskID={task.id}
                  typeID={task.task_type_id}
                />
              </Grid>
            ) : null}
          </Grid>
          {size === 'large' && stats ? (
            <Stats
              typeID={task.task_type_id}
              stats={task[stats]}
              taskID={task.id}
            />
          ) : null}
          <ListItemSecondaryAction
          // classes={{ root: classes.secondaryActionRoot }}
          >
            <Menu
              vert
              entityName={task.name}
              entityType={entityType}
              entityID={task.id}
              addOrEditPush={addOrEditPush}
            />
          </ListItemSecondaryAction>
        </ListItem>
      )
    },
  ),
)
